import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { apiPost } from '../../utils/request';
import { mustBeArray, requestHasError, getErrorMessage } from '../../utils/lib';
import { getRunFlag } from '../../utils/collectionTypes';
import { URGENT_DELIVERY_REQUEST_ID } from '../../constants';

const AddToRunModal = ({ isOpen, locationId, requestTypeId, onClose, onAdded }) => {
    const [searching, setSearching] = useState(false);
    const [adding, setAdding] = useState(false);
    const [runs, setRuns] = useState([]);
    const [searchAllLocations, setSearchAllLocations] = useState(false);

    const flagType = requestTypeId === URGENT_DELIVERY_REQUEST_ID ? 'Delivery' : 'Collection';

    const performSearch = (allLocations) => {
        setSearching(true);
        apiPost(`/api/runs/forlocation?allLocations=${allLocations}`, { id: locationId })
            .then(x => {
                if (requestHasError({ x })) {
                    toastr.error(`Error: ${getErrorMessage({ x })}`);
                    setRuns([]);
                } else {
                    setRuns(mustBeArray(x && x.data && x.data.runs).filter(r => getRunFlag(r.truckCollectionTypeCode) === flagType));
                }
                setSearching(false);
            });
    };

    useEffect(() => {
        if (isOpen && locationId) {
            setSearchAllLocations(false);
            performSearch(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, locationId]);

    const handleSearchAllLocationsToggle = () => {
        const next = !searchAllLocations;
        setSearchAllLocations(next);
        performSearch(next);
    };

    const handleAdd = (runId) => {
        setAdding(true);
        apiPost(`/api/runs/addlocationtorun?id=${runId}&locationId=${locationId}&requestTypeId=${requestTypeId}`)
            .then(x => {
                setAdding(false);
                if (requestHasError({ x })) {
                    toastr.error(`Error: ${getErrorMessage({ x })}`);
                } else {
                    onAdded();
                }
            });
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>Add to Run</ModalHeader>
            <ModalBody>
                <div>
                    Search all locations{' '}
                    <label className="switch switch-3d switch-primary">
                        <input
                            type="checkbox"
                            className="switch-input"
                            checked={searchAllLocations}
                            autoComplete="false"
                            onChange={handleSearchAllLocationsToggle}
                        />
                        <span className="switch-label" />
                        <span className="switch-handle" />
                    </label>
                </div>
                {searching && <div>Finding suitable runs... <i className="fa fa-cog fa-spin" /></div>}
                {!searching && (
                    <table className="table table-responsive table-sm">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Regions</th>
                                <th>Driver</th>
                                <th>Pickups</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {runs.length === 0 && (
                                <tr>
                                    <td colSpan="5">No runs found</td>
                                </tr>
                            )}
                            {runs.map(x => (
                                <tr key={x.id}>
                                    <td>{moment(x.timeStart).format('DD/MM/YYYY')}</td>
                                    <td>{x.regions}</td>
                                    <td>{x.driversFullName}</td>
                                    <td>{`${x.completePickupCount}/${x.pickupCount}`}</td>
                                    <td>
                                        <Button color="primary" disabled={adding} onClick={() => handleAdd(x.id)}>
                                            Add
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddToRunModal;
